import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  darkMode: false,
  fontFamily: 'Default',
  charSize: 5,
  pinyinSize: 5,
  charSpaceVal: 2
};
const uiSettingsSlice = createSlice({
  name: 'uiSettings',
  initialState,
  reducers: {
    setUISettings: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    },
    toggleDarkMode: state => {
      state.darkMode = !state.darkMode;
    },
    setFontFamily: (state, action) => {
      state.fontFamily = action.payload;
    },
    setCharSize: (state, action) => {
      state.charSize = action.payload;
    },
    setPinyinSize: (state, action) => {
      state.pinyinSize = action.payload;
    },
    setCharSpaceVal: (state, action) => {
      state.charSpaceVal = action.payload;
    },
    resetUISettings: () => initialState
  },
  extraReducers: builder => {
    builder.addCase('settingsSyncSuccess', (state, action) => {
      if (action.payload) {
        const {
          darkMode,
          fontFamily,
          charSize,
          pinyinSize,
          charSpaceVal
        } = action.payload;
        return {
          ...state,
          ...(darkMode !== undefined && {
            darkMode
          }),
          ...(fontFamily !== undefined && {
            fontFamily
          }),
          ...(charSize !== undefined && {
            charSize
          }),
          ...(pinyinSize !== undefined && {
            pinyinSize
          }),
          ...(charSpaceVal !== undefined && {
            charSpaceVal
          })
        };
      }
      return state;
    });
  }
});
export const {
  setUISettings,
  toggleDarkMode,
  setFontFamily,
  setCharSize,
  setPinyinSize,
  setCharSpaceVal,
  resetUISettings
} = uiSettingsSlice.actions;
export default uiSettingsSlice.reducer;